module.exports = __webpack_public_path__ + "img/cookie-1000.8b795500.jpeg";